import Analytics from '@segment/analytics.js-core/build/analytics';

const analytics = new Analytics({
  // Replace 'YOUR_WRITE_KEY' with your actual Segment source's write key
  writeKey: 'Tj43j1GOGLB9S8HBzC9Iq3ubenLZvzdI'
});

export default analytics;